import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { breakpoint } from '../../utils/breakpoint'

export interface DetailListItem {
  id: string
  label: ReactNode
  value: ReactNode
}

interface IDetailListProps {
  items: DetailListItem[]
}

export const DetailList: React.FC<IDetailListProps> = ({ items }) => (
  <StyledDetailList>
    {items.map(({ id, label, value }) => (
      <StyledDetailField key={id}>
        <dt>{label}</dt>
        <dd>{value}</dd>
      </StyledDetailField>
    ))}
  </StyledDetailList>
)

const StyledDetailList = styled.dl(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: ${theme.spacing.space8}rem;
    row-gap: ${theme.spacing.space6}rem;
    margin: 0;
    width: 100%;

    @media ${breakpoint.mobile} {
      grid-template-columns: 1fr;
    }
  `
)

const StyledDetailField = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.space1}rem;
    min-width: 0;

    dt {
      ${theme.typography.mixins.body({ size: 'five', fontWeight: 'regular' })}
      color: ${theme.color.text.body.primary};
    }

    dd {
      ${theme.typography.mixins.label({ size: 'three', fontWeight: 'bold' })}
      margin: 0;
      overflow-wrap: anywhere;
      color: ${theme.color.text.title.primary};
    }
  `
)
